import { render, staticRenderFns } from "./tz.vue?vue&type=template&id=60cf49df&"
import script from "./tz.vue?vue&type=script&lang=js&"
export * from "./tz.vue?vue&type=script&lang=js&"
import style0 from "./tz.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports